export default "__VITE_ASSET__CTHEMxys__"